module.exports = __webpack_public_path__ + "assets/img/logo_new.089a92aa.png";